import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom'
import 'core-js';
import 'babel-polyfill';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import '@/utils/request.js';
import '@/styles/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import es6Promise from 'es6-promise';
es6Promise.polyfill();

ReactDOM.render(
  // <React.StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
